import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeInputComponent } from './time-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TimeInputCustomControlDirective } from './time-input-custom.directive';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@NgModule({
  declarations: [TimeInputComponent, TimeInputCustomControlDirective],
  imports: [CommonModule, FormsModule, TranslateModule, ReactiveFormsModule, NgxMaterialTimepickerModule],
  exports: [TimeInputComponent, TimeInputCustomControlDirective],
})
export class TimeInputModule {}
